module.exports = __webpack_public_path__ + "static/school_obj6@2x-43657cbf4db26018a4af267e6ddda796.png";